import type { IteroOrder } from '../../../../../services/iteroBrowse';
import {
    NO_LAB,
    doctorLabel,
    formatScanDuration,
    orEmpty,
    procedureLabel,
    scannerModelLabel,
    type DetailFormatters
} from '../iteroBrowseFormat.ts';
import { knownFacts, type FactTile } from '../pane/knownFacts.ts';

// Three to a row: when and how long, who, then what and on which scanner.
export function orderFactTiles(order: IteroOrder, format: DetailFormatters): FactTile[] {
    return knownFacts([
        { label: 'Scanned', value: orEmpty(format.dateTime(order.scanningDate)) },
        { label: 'Duration', value: formatScanDuration(order.scanningTimeSeconds) },
        { label: 'Order', value: orEmpty(order.orderCode) },
        { label: 'Doctor', value: doctorLabel(order.doctorName, order.doctorLicenseNumber) },
        { label: 'Operator', value: orEmpty(order.scanningOperatorName) },
        { label: 'Lab', value: orEmpty(order.labName) ?? NO_LAB },
        { label: 'Procedure', value: procedureLabel(order.procedureName, order.procedureTypeName) },
        { label: 'Due', value: orEmpty(format.dateOnly(order.dueDate)) },
        {
            label: 'Scanner',
            value: scannerModelLabel(order.scannerModelId, order.scannerModelDescription)
        }
    ]);
}
